
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAltitude as ObiAltitudeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-altitude.js';
 
 
 

 
 export const ObiAltitude = createComponent({
   react: React,
   tagName: 'obi-altitude',
   elementClass: ObiAltitudeElement,
   events: {
     
   }
  });
 
 